export const treeTableStyles = {
  headerRow: {
    backgroundColor: "var(--mb-color-background-secondary)",
  },
};
